var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.124,
    height: 22,
    viewBox: "0 0 22.124 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.828-9.582,11.516-20.41a.679.679,0,0,0-.494-.215.679.679,0,0,0-.494.215L.172-9.582a.583.583,0,0,0,.021.945.613.613,0,0,0,.967,0l.9-.988V.688a.657.657,0,0,0,.215.473.657.657,0,0,0,.473.215H7.563a.635.635,0,0,0,.494-.215A.692.692,0,0,0,8.25.688l.043-6.875H13.75V.688a.692.692,0,0,0,.193.473.635.635,0,0,0,.494.215H19.25a.657.657,0,0,0,.473-.215.657.657,0,0,0,.215-.473V-9.625l.9.988a.7.7,0,0,0,.516.215.657.657,0,0,0,.473-.215A.591.591,0,0,0,21.828-9.582Zm-3.266-1.289V0H15.125V-6.875a.669.669,0,0,0-.193-.494.669.669,0,0,0-.494-.193H7.605a.669.669,0,0,0-.494.193.669.669,0,0,0-.193.494L6.875,0H3.438V-11l7.605-7.949,7.52,7.906Q18.562-10.914,18.563-10.871Z",
    transform: "translate(0.059 20.625)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a95f32ac20de770a2248d9379ecff1a9.svg";
export { ForwardRef as ReactComponent };